import { createNumberColumn, createTextColumn } from '@ipfabric/utils';
import { createFrontendOnlyColumn } from 'components/Table/columns/frontendOnlyColumn';
import { PolicyRowActions } from '../shared/PolicyRowActions';
import type { PolicyRowMode } from '../shared/policyFormMode';
import type { WriteScopes } from '../shared/useWriteScopes';
import type { EndpointPolicy } from './endpointPoliciesApi';

export type EndpointPoliciesTableRow = {
  id: string;
  name: string;
  description: string;
  scopes: number;
  roles: string;
  isSystem: boolean;
  policy: EndpointPolicy;
};

type EndpointPoliciesTableHandlers = {
  scopes: WriteScopes;
  onOpen: (policy: EndpointPolicy, mode: PolicyRowMode) => void;
  onDelete: (policy: EndpointPolicy) => void;
};

export const createEndpointPoliciesTableColumns = ({
  scopes,
  onOpen,
  onDelete,
}: EndpointPoliciesTableHandlers) => [
  createTextColumn<EndpointPoliciesTableRow>({
    key: 'id',
    title: 'ID',
    hidden: true,
  }),
  createTextColumn<EndpointPoliciesTableRow>({
    key: 'name',
    title: 'Policy name',
  }),
  createTextColumn<EndpointPoliciesTableRow>({
    key: 'description',
    title: 'Description',
  }),
  createNumberColumn<EndpointPoliciesTableRow>({
    key: 'scopes',
    title: 'Endpoints',
  }),
  createTextColumn<EndpointPoliciesTableRow>({ key: 'roles', title: 'Roles' }),
  createFrontendOnlyColumn<EndpointPoliciesTableRow>({
    key: 'actions',
    title: 'Actions',
    disabledSort: true,
    webDependencies: ['id'],
    render: (row) => (
      <PolicyRowActions
        id={row.id}
        testIdPrefix='endpoint-policies'
        readOnly={row.isSystem}
        scopes={scopes}
        onView={() => onOpen(row.policy, 'view')}
        onEdit={() => onOpen(row.policy, 'edit')}
        onDuplicate={() => onOpen(row.policy, 'duplicate')}
        onDelete={() => onDelete(row.policy)}
      />
    ),
  }),
];
